import axios from 'axios';
import { AuthService } from './auth.service';
import { ENDPOINTS } from '../constants/endpoints';
import { CreateHolidayDto, HolidayResponse } from '../interfaces/holiday.interface';

export const HolidayService = {
    getHolidaysByInstitution: async (): Promise<HolidayResponse> => {
        const institutionId = AuthService.getSelectedInstitution()!!;
        const response = await axios.get(ENDPOINTS.HOLIDAY.HOLIDAY_BY_INSTITUTION(institutionId), {
            headers: AuthService.getAuthHeader()
        });
        return response.data;
    },

    createHoliday: async (holiday: CreateHolidayDto): Promise<void> => {
        holiday.institutionId = AuthService.getSelectedInstitution()!!;
        await axios.post(ENDPOINTS.HOLIDAY.BASE, holiday, {
            headers: AuthService.getAuthHeader()
        });
    },

    updateHoliday: async (id: string, holiday: CreateHolidayDto): Promise<void> => {
        await axios.put(`${ENDPOINTS.HOLIDAY.BASE}/${id}`, holiday, {
            headers: AuthService.getAuthHeader()
        });
    },

    deleteHoliday: async (id: string): Promise<void> => {
        await axios.delete(ENDPOINTS.HOLIDAY.DELETE(id), {
            headers: AuthService.getAuthHeader()
        });
    }
};
